var map = {
	"./diamond-cut-1@3x.jpg": 57,
	"./diamond-cut-2@3x.jpg": 59,
	"./diamond-cut-3@3x.jpg": 61,
	"./diamond-cut-4@3x.jpg": 63,
	"./diamond-cut-5@3x.jpg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;